import { FC } from 'react';

import { FilterButton } from './FilterButton';

export const RemoveButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  return <FilterButton onClick={onClick} label="Remove all" />;
};
